module.exports = __webpack_public_path__ + "img/image18.22ef5cb2.png";